var config = require('../config.js')
module.exports = {
  getVenueDetail: config.host + '/tktbc/api/v1/venue/get/c',   //   获取火票剧院详情
  checkVenue: config.dramahost + '/thi/api/v1/DataCheck/Venue',// 检查场厅数据情况
  getTheaterVenueBaseInfo: config.dramahost + '/thi/api/v1/TheaterInfoMiddle/VenueBaseInfo',// 查询场厅信息
  searchTheatreVenueScheduleInfoByOrderForRecentMonth: config.dramahost + '/book/api/v1/TheatreVenueScheduleInfo/SearchByOrderForRecentMonth', // 查询-档期查询最近一月
  searchTheatreVenueScheduleInfoByOrder: config.dramahost + '/book/api/v1/TheatreVenueScheduleInfo/SearchByOrder', // 查询-档期查询
  getVenueGalleryInfo: config.dramahost + '/thi/api/v1/VenueInfo/QGallery', // 查询-场厅-图库信息(简要信息)
  getGalleryVenue: config.dramahost + '/thi/api/v1/VenueInfo/QGalleryVenue', // 查询-场厅-图库-场厅图
  getVenueGalleryTech: config.dramahost + '/thi/api/v1/VenueInfo/QGalleryTech', // 查询-场厅-图库-技术参数图
  updateVenueGallery: config.dramahost + '/thi/api/v1/VenueInfo/UGallery', // 更新-场厅图库组件相关信息
  getVenueInfoOnly: config.dramahost + '/thi/api/v1/VenueInfo/QNJById', // 获取剧院场厅数据，仅仅是剧院场厅数据
  getRoundService: config.dramahost + '/thi/api/v1/TheaterInfo/QRearService', // 查询剧院周边服务
  getTmServices: config.dramahost + '/thi/api/Service/Services', //获取剧院的所有保障服务
  // checkVenue: config.host + '/thi/api/v1/DataCheck/Venue',// 检查场厅数据情况
  // checkVenue: config.host + '/thi/api/v1/DataCheck/Venue',// 检查场厅数据情况
  // checkVenue: config.host + '/thi/api/v1/DataCheck/Venue',// 检查场厅数据情况
  // checkVenue: config.host + '/thi/api/v1/DataCheck/Venue',// 检查场厅数据情况
  // checkVenue: config.host + '/thi/api/v1/DataCheck/Venue',// 检查场厅数据情况
  // checkVenue: config.host + '/thi/api/v1/DataCheck/Venue',// 检查场厅数据情况

  getVenueList: config.host + '/tktbc/api/v1/venue/list/c', // 查询场厅列表（不带详情）
  

}